import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled, { keyframes } from 'styled-components';

class SpinnerBig extends PureComponent {
  static propTypes = {
    bg: PropTypes.string,
  };

  static defaultProps = {
    bg: '#fff',
  };

  render() {
    return (
      <Wrapper bg={this.props.bg}>
        <CircleWrapper>
          <LoadingCircle />
          <Text>LOADING</Text>
        </CircleWrapper>
      </Wrapper>
    );
  }
}

const LoadingKeyframes = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const TextKeyframes = keyframes`
    0% {
        opacity: 1;
    }
    20% {
        opacity: 0.5;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0.5;
    }
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  z-index: 200;
  background-color: ${(props) => props.bg};
`;

const LoadingCircle = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-width: 2px;
  border-color: transparent #aaa transparent #aaa;
  border-style: solid;
  border-radius: 100%;
  animation: ${LoadingKeyframes} 1.5s linear 0s infinite normal;
`;

const Text = styled.div`
  font-size: 10px;
  font-weight: bold;
  position: absolute;
  color: #aaa;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  animation: ${TextKeyframes} 2s linear 0s infinite normal;
`;

const CircleWrapper = styled.div`
  position: absolute;
  margin: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
`;

export default SpinnerBig;
